import { bankingSolutionsData } from "@/mocks/homeData";

export default function BankingSection() {
  return (
    <section id="banking" className="w-full py-16 md:py-24 bg-foreground-950">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-accent-500 uppercase tracking-wider">
            Specialized Expertise
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-background-50 mt-2 mb-4">
            {bankingSolutionsData.headline}
          </h2>
          <p className="text-background-300 leading-relaxed">
            {bankingSolutionsData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto">
          {bankingSolutionsData.solutions.map((solution) => (
            <div
              key={solution.title}
              className="group bg-foreground-900/50 rounded-xl p-5 md:p-6 border border-foreground-800/60 hover:border-accent-500/40 transition-all"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-accent-500/15 flex items-center justify-center mb-4">
                <i className={`${solution.icon} text-xl md:text-2xl text-accent-500`} />
              </div>
              <h4 className="font-heading font-semibold text-lg md:text-xl text-background-50 mb-3">
                {solution.title}
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                {solution.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}